"use client";

import { useEffect, useState } from "react";
import type { Locale } from "./getLocale";

// ES sweep (feat/81): client-side locale for the signed-in portal.
// The TopBar toggle writes the mag-locale cookie and portal routes are
// never /es-prefixed, so the cookie is the only signal - same read the
// confirmation page introduced in PASTE #277.

export function readClientLocale(): Locale {
  if (typeof document === "undefined") return "en";
  return document.cookie.includes("mag-locale=es") ? "es" : "en";
}

// Effect-based (not a lazy useState initializer) so the first client
// render matches the EN server HTML - no hydration mismatch when the
// cookie says "es". The ES strings land in the same commit as the
// pages' own hydration flags, so visible content never flashes EN.
export function useClientLocale(): Locale {
  const [locale, setLocale] = useState<Locale>("en");
  /* eslint-disable react-hooks/set-state-in-effect -- one-time cookie read after hydration */
  useEffect(() => {
    setLocale(readClientLocale());
  }, []);
  /* eslint-enable react-hooks/set-state-in-effect */
  return locale;
}
